import { formatPrice } from "../../../utils/Utils";
import moment from "moment";
import ShoppingCart from "../../../components/shopping-cart/ShoppingCart";
import Auth from "../../../libs/API/Auth";
import Agreements from "../../../libs/API/Agreements";

class CampaignPlanningConfirmationModalPayment {
  constructor() {
    this.main = document.getElementById('checkout_modal_payment');
    this.data = null;

    this._paymentOptionDigital = this.main.querySelector('.payment-option[data-type="Digital"]') || null;
    this._paymentOptionStatic = this.main.querySelector('.payment-option[data-type="Static"]');
    this._totalPrice = this.main.querySelectorAll('.total-price');
    this._limitPrice = this.main.getAttribute('data-price-limit');

    this._modalOptionsContent = this.main.querySelector('.modal-options');
    this._modalStatusContent = this.main.querySelector('.modal-status');
    this._modalResponseContent = this.main.querySelector('.modal-response');
    this._modalGeneratingContract = this.main.querySelector('.modal-generating-contract');


    this._btnClose = this.main.querySelector('.btn_close');
    this._btnCloseError = this.main.querySelector('.btn_close_error');

    this._btnCloseError.addEventListener('click', this._onClickBtnCloseError.bind(this));
    this._btnClose.addEventListener('click', this._onClickBtnClose.bind(this));
    this._paymentOptionStatic.addEventListener('click', (e) => { this.main.dispatchEvent(new CustomEvent('CONTACT_SALE_REP')) });
    if (this._paymentOptionDigital != null) this._paymentOptionDigital.addEventListener('click', this._onClickPaymentDigital.bind(this) );
  }

  set setResponseContent(message) {
    if (message) {
      this._modalResponseContent.querySelector('.modal-response--text').innerHTML = `${message}`;
    }
  }

  set showStatusContent(value) {
    if (value) {
      this._modalOptionsContent.classList.add('d-none');
      this._modalStatusContent.classList.remove('d-none');
    } else {
      this._modalOptionsContent.classList.remove('d-none');
      this._modalStatusContent.classList.add('d-none');
    }
  }

  set showResponseContent(value) {
    if (value) {
      this._modalStatusContent.classList.add('d-none');
      this._modalResponseContent.classList.remove('d-none');
    } else {
      this._modalStatusContent.classList.remove('d-none');
      this._modalResponseContent.classList.add('d-none');
    }
  }

  set setOptions(data) {
    this.data = data;

    if (this.data.campaign_summary.digital.billboard_count >= 1 && this._paymentOptionDigital != null) {
      this._paymentOptionDigital.querySelector('.count-digital').innerHTML = this.data.campaign_summary.digital.billboard_count;
      this.main.querySelectorAll('.count-digital').forEach((elem) => { elem.innerHTML = this.data.campaign_summary.digital.billboard_count });
    } else {
      this.main.querySelectorAll('.detail-digital').forEach((elem) => { elem.classList.add('d-none') });
    }

    if (this.data.campaign_summary.static.billboard_count >= 1) {
      this.main.querySelectorAll('.detail-static').forEach((elem) => { elem.classList.remove('d-none') });
      this._paymentOptionStatic.querySelector('.count-static').innerHTML = this.data.campaign_summary.static.billboard_count;
      this._paymentOptionDigital.querySelector('.count-static').innerHTML = this.data.campaign_summary.static.billboard_count;
    } else {
      this.main.querySelectorAll('.detail-static').forEach((elem) => { elem.classList.add('d-none') });
    }

    /* Si tiene ambos tipos de billboards muestro el separador*/
    if (this.data.campaign_summary.static.billboard_count >= 1 && this.data.campaign_summary.digital.billboard_count >= 1) {
      this._paymentOptionStatic.querySelector('.separator').classList.remove('d-none');
      this._paymentOptionDigital.querySelector('.separator').classList.remove('d-none');
    } else {
      this._paymentOptionStatic.querySelector('.separator').classList.add('d-none');
      this._paymentOptionDigital.querySelector('.separator').classList.add('d-none');
    }
    if (this.data.campaign_summary.ai_credits) {
      this.main.querySelectorAll('.detail-ad-builder').forEach((elem) => { elem.classList.remove('d-none') });
      this._paymentOptionDigital.querySelector('.count-ad-builder').innerHTML = this.data.campaign_summary.ai_credits.amount;
      this._paymentOptionStatic.querySelector('.count-ad-builder').innerHTML = this.data.campaign_summary.ai_credits.amount;
    } else {
      this.main.querySelectorAll('.detail-ad-builder').forEach((elem) => { elem.classList.add('d-none') });
    }


    let totalPrice = this.data.campaign_summary.total.price;
    if (this.main.querySelector('.order-summary-notification-max-amount-payment')) {
      if (parseInt(totalPrice) > parseInt(this._limitPrice)) {
        this.main.querySelector('.order-summary-notification-max-amount-payment').classList.remove('d-none');
        this._paymentOptionDigital.classList.add('payment-option--disable');
      } else {
        this.main.querySelector('.order-summary-notification-max-amount-payment').classList.add('d-none');
        this._paymentOptionDigital.classList.remove('payment-option--disable');
      }
    }

    this._totalPrice.forEach((price) => {
      price.innerHTML = formatPrice(totalPrice);
    })

  }

  addEventListener(event, callback) {
    this.main.addEventListener(event, callback);
  }

  _generateContract(){
    const payload = {
      'with_css': false,
      'customer_name': Auth.user.full_name,
      'brand_name': ShoppingCart.data.brand.name,
      'crm_opportunity_id': '',
      'from_date': moment(ShoppingCart.fromDate).format('MM/DD/YY'),
      'to_date': moment(ShoppingCart.toDate).format('MM/DD/YY'),
      'price': ShoppingCart.getTotalCartNumber,
      'billboards': ShoppingCart.data.items.map((item) => {
          return {
              id: item.id,
              name: item.name,
              location_name: item.location.name,
              format_name: item.format.name,
              from_date: moment(item.dateRange.from).format('MM/DD/YY'),
              to_date: moment(item.dateRange.to).format('MM/DD/YY'),
              price: item.price,
              period_length: item.days_available,
              frequency: 'daily',
              spot_type: 'guarantee',
              space_exposure: 100
          }
      })
    };

    return Agreements.agreementPDF(payload,true);
  }

  async _onClickPaymentDigital(){
    this._modalOptionsContent.classList.add('d-none');
    this._modalGeneratingContract.classList.remove('d-none');
    try {
      const response = await this._generateContract();
      if(response){
        this.main.dispatchEvent(new CustomEvent('SHOW_CONTRACT_MODAL', {
          bubbles: false,
          detail:{
              html: response
          }
        }));
        //PAYMENT_FUNNEL
        this.hide();
        setTimeout(() => {
          this._modalOptionsContent.classList.remove('d-none');
          this._modalGeneratingContract.classList.add('d-none');
        }, 500);
      }
    } catch (error) {
        this._modalGeneratingContract.classList.add('d-none');
        this.setResponseContent = error;
        this.showResponseContent = true;
    }
  }

  show() {
    this.main.classList.add('modal--show');
    document.body.classList.add('block-scroll');
    setTimeout(() => {
      this.main.classList.add('modal--anim');
    }, 50);
  }

  hide() {
    this.loading = false;
    this.main.classList.remove('modal--anim');
    setTimeout(() => {
      this.main.classList.remove('modal--show');
      document.body.classList.remove('block-scroll');
    }, 750);
  }

  set loading(value) {
    if (value) {
      this.main.classList.add('loading');
    } else {
      this.main.classList.remove('loading');
    }
  }

  _onClickBtnClose(e) {
    e.preventDefault();
    this.hide();
  }

  _onClickBtnCloseError(e) {
    e.preventDefault();
    location.reload();
  }

}

export default CampaignPlanningConfirmationModalPayment;